import { useQuery } from '@tanstack/react-query';
import { adminClient } from '@/lib/adminClient';

export const accountKeys = {
  all: ['accounts'] as const,
  list: (filters: Record<string, string | number | undefined>) =>
    [...accountKeys.all, 'list', filters] as const,
  detail: (id: string) => [...accountKeys.all, 'detail', id] as const,
  recipient: (id: string) => [...accountKeys.all, 'recipient', id] as const,
  linkedAccount: (id: string) => [...accountKeys.all, 'linkedAccount', id] as const,
};

export function useLedgerAccounts(filters: { pageSize?: number; pageToken?: string }) {
  return useQuery({
    queryKey: accountKeys.list(filters),
    queryFn: () => adminClient.listLedgerAccounts(filters),
  });
}

export function useLedgerAccount(accountId: string) {
  return useQuery({
    queryKey: accountKeys.detail(accountId),
    queryFn: () => adminClient.getLedgerAccount(accountId),
    enabled: !!accountId,
  });
}

// The two lookups below classify a UUID account id: at most one of them (or
// the user lookup) matches, and a miss is expected rather than a failure, so
// they don't retry.

export function useRampRecipient(recipientId: string) {
  return useQuery({
    queryKey: accountKeys.recipient(recipientId),
    queryFn: () => adminClient.getRampRecipient(recipientId),
    enabled: !!recipientId,
    retry: false,
  });
}

export function useRampLinkedAccount(accountId: string) {
  return useQuery({
    queryKey: accountKeys.linkedAccount(accountId),
    queryFn: () => adminClient.getRampLinkedAccount(accountId),
    enabled: !!accountId,
    retry: false,
  });
}
